import { render } from "./TextareaBox.vue?vue&type=template&id=222cbbc2&scoped=true"
import script from "./TextareaBox.vue?vue&type=script&lang=js"
export * from "./TextareaBox.vue?vue&type=script&lang=js"

import "./TextareaBox.vue?vue&type=style&index=0&id=222cbbc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222cbbc2"]])

export default __exports__